"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
var LicenseType;
(function (LicenseType) {
    LicenseType["Fairplay"] = "FairplayLicense";
    LicenseType["Playready"] = "PlayreadyLicense";
    LicenseType["Widevine"] = "WidevineLicense";
})(LicenseType = exports.LicenseType || (exports.LicenseType = {}));
//# sourceMappingURL=LicenseType.js.map